require('./helpers/bundle-manifest').register(JSON.parse("{\"2347G\":\"main.js\",\"8SbwU\":\"photoswipe.esm.c1ec61a8.js\",\"aexll\":\"main.css\"}"));